import {$qs} from '../../@shared/ts/dom';

/**
 * To update the UI state based on the navigation hash, adds 'section-[hash]' to .pp-admin-content-wrapper.
 */
function setInnerView(hash: string) {
	const $elementWithSectionHash = $qs('.pp-admin-content-wrapper');
	if ($elementWithSectionHash) {
		let className = $elementWithSectionHash.className.replace(/(^|\s)section-[a-z]*($|\s)/g, '');
		className += ` section-${hash} `;
		$elementWithSectionHash.className = className;
	}
}

/**
 * Checks if the cursor is within the given bounds.
 */
function cursorIsWithinBounds(event: Event, bounds: DOMRect) {
	const mouseX = (event as MouseEvent).clientX;
	const mouseY = (event as MouseEvent).clientY;

	return mouseX > (bounds.left - 8) && mouseX < (bounds.right + 8) && mouseY > (bounds.top - 8) && mouseY < (bounds.bottom + 8);
}

/**
 * Returns the given element's value.
 */
function getValue($element: HTMLElement) {
	if ($element.tagName === 'INPUT' && ['checkbox', 'radio'].includes(($element as HTMLInputElement).type)) {
		return ($element as HTMLInputElement).checked;
	}

	if ($element.tagName === 'INPUT') {
		return ($element as HTMLInputElement).value;
	}

	if ($element.tagName === 'TEXTAREA') {
		return ($element as HTMLTextAreaElement).value;
	}

	if ($element.hasAttribute('data-select2-id') && $element.hasAttribute('multiple')) {
		const selectedOptions: string[] = [];
		Array.from((($element.nextElementSibling as HTMLElement)?.querySelectorAll('.select2-selection__choice'))).forEach(($selected: HTMLElement) => {
			selectedOptions.push($selected.getAttribute('data-select2-id') ?? '');
		});
		return selectedOptions.sort();
	}

	if ($element.hasAttribute('data-select2-id')) {
		return ($element.nextElementSibling as HTMLElement)?.querySelector('.select2-selection__rendered')?.getAttribute('title');
	}

	if ($element.tagName === 'SELECT') {
		return ($element as HTMLSelectElement).value;
	}

	if ($element.tagName === 'TR') {
		// return the element's index in the parent element
		return Number([].indexOf.call($element.parentElement?.children, $element));
	}

	if ($element.id === 'list-item') {
		return $element.innerHTML.replace(/(\/(?=[a-z]).|\s)/g, '');
	}

	return '';
}

/**
 * Returns true if the element's value has changed.
 */
function elementHasChanged($element: HTMLElement) {
	return String(getValue($element)) !== $element.getAttribute('data_originalValue');
}

/**
 * Checks if the inner content is wider than the element.
 */
function contentTooWide($parent: HTMLElement) {
	const parentWidth = $parent.clientWidth;
	const {children} = $parent;
	let widthSum = 0;
	// eslint-disable-next-line @typescript-eslint/prefer-for-of
	for (let i = 0; i < children.length; i++) {
		const width = children[i]?.clientWidth;
		if (width) {
			widthSum += width;
		}
	}

	return widthSum > parentWidth;
}

export {setInnerView, cursorIsWithinBounds, contentTooWide, getValue, elementHasChanged};
